import { CommonModule } from '@angular/common'; 
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-terms-conditions',
    templateUrl: './terms-conditions.page.html'
})
export class TermsConditionsPage implements OnInit {
  supportURL: string = environment.supportURL;
  webURL: string = environment.webURL;

  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('Terms and conditions: gigexchange');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'These terms and conditions explain the terms that apply when you access our Services and our website.' }
    )
  }

}
